import netcoServer from '../../apis/netcoServer';
import loadingCall from "../helpers/loadingCall";

const checkLoggedIn= (callback) => async (dispatch) => {
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/LoginService/isLoggedIn', {}));
  if(callback)
    callback(response.data.loggedIn);
};
export default checkLoggedIn;